import React from 'react';
import { IEntityDetailsProps } from './detailsTypes';
import { PreviewPanel } from './Panels/Preview';
import { DescriptionPanel } from './Panels/Description';
import { DetailsFileLoader } from './Panels/DetailsFileLoader';
import { PrimaryActions } from './Panels/PrimaryActions';
import { EmptyPanel } from './Panels/EmptyPanel';
import { ValidationPanel } from './Panels/ValidationPanel';
import { DependenciesPanel } from './Panels/Dependecies/Dependencies';
import { HistoryPanel } from './Panels/History';
import { getPanelClasses } from './Panels/panelSettings';

export function PrimaryDetails(props: IEntityDetailsProps) {
  const showDeps: boolean =
    !!(props.dependencyFrom && props.dependencyFrom.length) || !!(props.dependencyTo && props.dependencyTo.length);
  const showHistory: boolean = !!(props.history && props.history.length);
  const showDescription: boolean = !!(props.description && props.description.length);
  const showDownload: boolean = !!(props.downloadDocument || props.getUploadHolder);
  const showActionBar: boolean = !!(props && props.actionBarProps && props.actionBarProps.actionGroups);

  const isEmpty: boolean = !(
    showDownload ||
    showDescription ||
    props.previewUrl ||
    props.loadValidationIssues ||
    showDeps ||
    showHistory
  );

  return (
    <div className={getPanelClasses('left', 12, 8)}>
      <div className="dp-entitydetails__title" title={props.entityName}>
        {props.entityName}
      </div>
      {showActionBar && <PrimaryActions {...props.actionBarProps} />}
      {showDownload && (
        <DetailsFileLoader downloadDocument={props.downloadDocument} getUploadHolder={props.getUploadHolder} />
      )}
      {props.statusNote && <DescriptionPanel description={props.statusNote} title="Status Note" />}
      {showDescription && <DescriptionPanel description={props.description} />}
      {props.previewUrl && <PreviewPanel previewUrl={props.previewUrl} />}
      {props.loadValidationIssues && (
        <ValidationPanel
          loadValidationIssues={props.loadValidationIssues}
          entityId={props.entityId}
          typeName={props.typeName}
        />
      )}
      {showDeps && (
        <DependenciesPanel
          dependencyTo={props.dependencyTo}
          dependencyFrom={props.dependencyFrom}
          registrationClick={props.registrationClick}
        />
      )}
      {showHistory && <HistoryPanel history={props.history} />}
      {isEmpty && <EmptyPanel />}
    </div>
  );
}
